import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { RoomDetailContainerJustifyContent, RoomDetailVariant } from './constants';
import { mediaQueryMobileLimit } from '../../../../utils/constants';
export const RoomDetailStyled = {
  Container: styled(Grid) <any>`
    margin-top: 48px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin-top: 0px;
     }
  `,
  ContainerRoom: styled(Grid) <any>`
    display: flex;
    justify-content: ${(props: any) => {
      const variant: RoomDetailVariant = props.variant;
      return RoomDetailContainerJustifyContent[variant];
    }};
    width: 100%;
  `,
  RoomName: styled.p<any>`
    font-family: EncodeSans-Bold;
    font-size: 20px;
    margin-bottom: 5px;
  `,
  RoomDescription: styled.p<any>`
    font-family: EncodeSans-regular;
    font-size: 13px;
    margin-bottom: 15px;
  `,
  ContainerDetails: styled(Grid) <any>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 45px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
     padding: 30px 30px 0px 30px;
     
     }
  `,
  ContainerImages: styled(Grid) <any>`
    width: 100%;
    border-radius: 10px;
      height: 350px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      padding: 30px;
      height: auto;
     }  
  `,
  ContainerButton: styled.div<any>`
    min-width: 167px;
    max-width: 167px;
    
  `,
  Image: styled.img<any>`
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
  ContainerCarousel: styled(Grid) <any>`
    position: relative;
    margin: ${(props: any) => props.margindesktop};
    @media (max-width: 900px) {
      margin: ${(props: any) => props.marginmobile};
    },
  `,
};
